import "react"
import { motion } from "framer-motion"

import {RiDownloadLine} from "react-icons/ri"

import Tag from "./Tag"
import Circle from "../misc/Circle"

export type Song = {
    title: string;
    bpm: number;
    keyString: string;
    tags: string[];
    fileLink?: string;
}

const _downloadIndicator = {
    "welcome": { opacity: 0, scale: 0.7},
    "personalized_packs": { opacity: 0, scale: 0.7 },
    "boring_work": { opacity: 0, scale: 0.7 },
    "insights":  { opacity: 1, scale: 1 },
}

export type AudioRowProps = Song & {opacity?: number; downloadIndicator?: boolean;}
export default function AudioRow({ title, bpm, keyString, tags, opacity, fileLink, downloadIndicator }: AudioRowProps) {
    return <motion.div className={`group relative p-4 px-6 rounded cursor-default flex justify-between items-center  transition-opacity  hover:bg-dark-gray`} style={{opacity: opacity/100}}>
        {/* {<div
        className={`absolute left-0 top-1/2 -translate-y-1/2 transition ${downloadIndicator ? 'opacity-100' : 'opacity-0'}`} 
        ><RiDownloadLine size={18}/>
         </div>} */}
        <div>
            <div className="text-lg text-white mb-">{title}</div>
            <div className="text-light-gray text-sm">{bpm} bpm <Circle/> {keyString}</div>
        </div>

        
        <div className="relative">
            <div className="transition opacity-100 group-hover:opacity-0 ">{tags.map(t => <Tag key={`${title}-tag-${t}`}>{t}</Tag>)}</div>
            {fileLink && <a download href={fileLink} style={{right: -12}} className="cursor-pointer absolute right-0 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-opacity opacity-0 group-hover:opacity-100 ">
                <RiDownloadLine width={22} size={22} className={"opacity-75 hover:opacity-100"}/>
            </a> }
        </div>
    </motion.div>
}